import { CreatorPage } from "@/components/creators";
import { useLoggedInUser } from "@/components/providers/ApiProvider/hooks";
import { useAudiolab } from "@/components/providers/AudiolabProvider/hooks";
import { Flex, Spinner } from "@radix-ui/themes";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

export const Route = createFileRoute("/audiolab/creators/$CREATOR_ID")({
  component: AudiolabCreatorPage,
  head: () => ({
    meta: [{ title: "Artist Profile | Lutely" }],
  }),
});

function AudiolabCreatorPage() {
  const { CREATOR_ID } = Route.useParams();
  const navigate = useNavigate();
  const { isSuccess } = useLoggedInUser();
  const { allCreators } = useAudiolab();

  const isInLabel = allCreators.some((c) => c.creatorId === CREATOR_ID);

  useEffect(() => {
    if (isSuccess && !isInLabel) {
      navigate({
        to: "/creators/$CREATOR_ID",
        params: { CREATOR_ID },
        replace: true,
      });
    }
  }, [isSuccess, isInLabel, CREATOR_ID, navigate]);

  if (!isSuccess || !isInLabel) {
    return (
      <Flex className="min-h-screen w-full items-center justify-center">
        <Spinner size="3" />
      </Flex>
    );
  }

  return (
    <CreatorPage
      key={CREATOR_ID}
      creatorIdOrSlug={CREATOR_ID}
      hideFilterSection
      showAudiolabNav
    />
  );
}
